export const TIMELINE_NAVIGATE = 'TIMELINE_NAVIGATE';
export const IFRAME_NAVIGATE = 'IFRAME_NAVIGATE';
export const ADD_QUERY_PARAMS = 'ADD_QUERY_PARAMS';
export const REMOVE_QUERY_PARAMS = 'REMOVE_QUERY_PARAMS';